<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';
import SelecteurTypeDonnee from '@/components/generiques/SelecteurTypeDonnee.vue';

const { idErreur, proposerTypesObjets, desactive } = defineProps({
    idErreur: String,
    proposerTypesObjets: Boolean,
    desactive: Boolean
});

const valeur = defineModel('valeur', {
    type: Object
});

const erreursSaisie = inject('erreursSaisie');

function modifierValeur(typeDonnee) {
    valeur.value = typeDonnee;
}

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <SelecteurTypeDonnee 
            v-model:typeDonnee="valeur" 
            :proposer-types-objets="proposerTypesObjets" 
            :desactive="desactive"
            @modification="modifierValeur" />
    </Saisie>
</template>

<style scoped>

</style>